import { ArrowUpRight, Image } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import useLinkedInPost from "../../../datahooks/useLinkedInPost";

export default function PostTargetingLabel({
  isLoading,
  postId,
}: {
  isLoading: boolean;
  postId: string;
}) {
  const { linkedInPost, isLoadingLinkedInPost } = useLinkedInPost(postId);

  if (isLoading || isLoadingLinkedInPost)
    return <Skeleton className="h-7 w-44" />;

  if (!linkedInPost)
    return (
      <Tag size="lg" variant="primary-black" leftIcon={<Image weight="fill" />}>
        Post Campaign
      </Tag>
    );

  return (
    <Tag
      size="lg"
      variant="primary-black"
      leftIcon={<Image weight="fill" />}
      rightIcon={<ArrowUpRight />}
      className="max-w-full duration-300 ease-in-out hover:bg-black-700"
      asChild
    >
      <a
        href={`https://www.linkedin.com/feed/update/urn:li:activity:${postId}`}
        target="_blank"
        rel="noreferrer"
      >
        <span className="truncate">{linkedInPost.author.name}&apos;s post</span>
      </a>
    </Tag>
  );
}
